import { render, staticRenderFns } from "./MachineCard.vue?vue&type=template&id=60baca1b&scoped=true&"
import script from "./MachineCard.vue?vue&type=script&lang=js&"
export * from "./MachineCard.vue?vue&type=script&lang=js&"
import style0 from "./MachineCard.vue?vue&type=style&index=0&id=60baca1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60baca1b",
  null
  
)

export default component.exports